import React from "react";
import Dialog from "./dialog";
import { Description, DialogPanel, DialogTitle } from "@headlessui/react";
import { apiBaseUrl } from "../consts/api-url.const";
export const ConnectSpotifyPopup = (props: any) => {
  const { setIsModalOpen, isModalOpen, isSongSubmit, trackId, playlistId, page } =
    props;

  const handleConnect = async () => {
      // Use configured API domain so the registered Spotify redirect URI matches
      const authBaseUrl = apiBaseUrl;
      // Remember current page so we can return here after Spotify login
      const currentUrl = window.location.href;
      window.localStorage.setItem("postLoginRedirect", currentUrl);
      const redirectUrl = encodeURIComponent(currentUrl);
      window.location.href = `${authBaseUrl}/api/auth/login`;
  };
  return (
    <>
      <Dialog
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        className="relative z-10"
      >
        <DialogPanel
          className="max-w-lg w-full space-y-4 bg-[#0E0E10] shadow-dialogShadow px-8 py-10 rounded-[20px]"
          style={{
            backgroundImage: "url('/image/dialog-bg.webp')",
            backgroundSize: "110%",
            backgroundPosition: "center top",
          }}
        >
          <DialogTitle className="text-2xl font-semibold text-center">
            {isSongSubmit ? "Submit a Track" : "Submit a Playlist"}
          </DialogTitle>
          <Description className="text-white/75 text-center">
            {isSongSubmit
              ? 'To submit a track to playlists, authenticate with your Spotify profile by clicking the green "Connect with Spotify" button'
              : 'To submit your playlist, authenticate with your Spotify profile by clicking the green "Connect with Spotify" button'}
          </Description>
          <div className="!mt-8 text-center">
            <button
              className="button button--secondary button--with-icon footer-button p-3"
              onClick={handleConnect}
            >
              <img src="/image/Spoty-logo.webp" alt="Spotify Logo" title="Spotify Logo" width="35" height="35" loading="lazy" />
              Connect with Spotify
            </button>
          </div>
        </DialogPanel>
      </Dialog>
    </>
  );
};
